// extracted by mini-css-extract-plugin
module.exports = {"polls-button":"PollsContainer_polls-button__G0eT8","polls-icon":"PollsContainer_polls-icon__38S5t","polls-container":"PollsContainer_polls-container__388UD"};